import { useState, useEffect } from 'react';
import { FamlaServices } from '../services';
import { useAppSelector } from './../stores/store';

function processItemId(item: { _id?: string; id?: string } | null | undefined): string | null {
    const id = item?._id ?? item?.id;
    return id != null ? String(id) : null;
}

function dedupeProcessSearchResults(items: any[]): any[] {
    const seen = new Set<string>();
    return items.filter((item) => {
        const id = processItemId(item);
        if (!id || seen.has(id)) return false;
        seen.add(id);
        return true;
    });
}

const useSearch = (url: string, companyId?: string, enrichData: boolean = false) => {
    const token = useAppSelector((state) => state.auth.access_token);
    const [searchQuery, setSearchQuery] = useState<string | undefined>('');
    const [searchResults, setSearchResults] = useState<any[]>([]);
    const [searchLoad, setSearchLoad] = useState(false);
    const defaultFilter = url === '/process/search/my/process' ? 'ALL' : 'TITLE';
    const [filter, setFilter] = useState<string | undefined>(defaultFilter);

    // Fonction pour récupérer `timeSaved` et `mappingCreationDate`
    const getProcessStats = async (processId: string): Promise<{ timeSaved: number; mappingCreationDate: string }> => {
        try {
            let response = await FamlaServices("api_host", `/stats/process/${processId}`, "GET", "", token);
            if (response.status === 200) {
                return {
                    timeSaved: response.body.data || 0,
                    mappingCreationDate: response.body.time || "",
                };
            }
        } catch (e) { }
        return { timeSaved: 0, mappingCreationDate: "" };
    };

    useEffect(() => {
        const fetchSearchResults = async () => {
            if (searchQuery && token) {
                setSearchLoad(true);
                const requestData = { search: searchQuery, filter, company_id: companyId };
                try {
                    const res = await FamlaServices("api_host", url, 'POST', requestData, token);
                    const isSuccess = res.status === 200 || res.status === 201;
                    const rawData = isSuccess ? res.body?.data : null;
                    let dataList = Array.isArray(rawData) ? rawData : [];

                    if (isSuccess && enrichData) {
                        dataList = await Promise.all(
                            dataList.map(async (process: any) => {
                                const { timeSaved, mappingCreationDate } = await getProcessStats(process._id);
                                return { ...process, timeSaved, mappingCreationDate };
                            })
                        );
                    }

                    if (url === '/process/search/my/process') {
                        dataList = dedupeProcessSearchResults(dataList);
                    }

                    setSearchResults(isSuccess ? dataList : []);
                } catch {
                    setSearchResults([]);
                } finally {
                    setSearchLoad(false);
                }
            } else {
                setSearchResults([]);
                setSearchLoad(false);
            }
        };

        fetchSearchResults();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, searchQuery, url, filter, companyId]);

    return { searchQuery, setSearchQuery, searchResults, searchLoad, setFilter, filter };
};

export default useSearch;
